// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__30rzC","buttons":"styles_buttons__1gHXj"};